import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
const originalPush = VueRouter.prototype.push;
const flag = navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
const postId = localStorage.getItem("iuPost") * 1;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
//console.log(flag);
const routes = [
  {
    path: "",
    redirect: "/dologin",
  },

  {
    path: "/dologin",
    name: "dologin",
    component: () => import("../views/doLogin.vue"),
    meta: {
      title: "登录",
    },
  },

  {
    path: "/Home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    children: [
      {
        path: "",
        redirect: "/Home/userList",
      },
      {
        path: "userList",
        name: "userList",
        component: () => import("../views/user/userList"),
      },
      {
        path: "commercialTenant",
        name: "commercialTenant",
        component: () => import("../views/commercialTenant/commercialTenant"),
      },
      {
        path: "MerchantBill",
        name: "MerchantBill",
        component: () => import("../views/MerchantBill/MerchantBill"),
      },
      {
        path: "MakeRoll",
        name: "MakeRoll",
        component: () => import("../views/MakeRoll/MakeRoll"),
      },
      {
        path: "withdrawal",
        name: "withdrawal",
        component: () => import("../views/MerchantBill/withdrawal"),
      },
      {
        path: "wxBill",
        name: "wxBill",
        component: () => import("../views/MerchantBill/wxBill"),
      },
      {
        path: "InvoiceReminder",
        name: "InvoiceReminder",
        component: () => import("../views/InvoiceReminder/InvoiceReminder"),
      },
      {
        path: "SystemLog",
        name: "SystemLog",
        component: () => import("../views/sysLog/SystemLog"),
      },
      {
        path: "OptionalBankRange",
        name: "OptionalBankRange",
        component: () => import("../views/OptionalBankRange/OptionalBankRange"),
      },
      {
        path: "InvoiceType",
        name: "InvoiceType",
        component: () => import("../views/InvoiceReminder/InvoiceType"),
      },
      {
        path: "MerchantUser",
        name: "MerchantUser",
        component: () => import("../views/MerchantUser/MerchantUser"),
      },
      {
        path: "cityList",
        name: "cityList",
        component: () => import("../views/cityList/cityList"),
      },
      {
        path: "authority",
        name: "authority",
        component: () => import("../views/authority/authority"),
      },
      {
        path: "role",
        name: "role",
        component: () => import("../views/authority/role"),
      },
      {
        path: "InvoiceTypeSh",
        name: "InvoiceTypeSh",
        component: () => import("../views/InvoiceTypeSh/InvoiceTypeSh"),
      },
      {
        path: "CardSpecification",
        name: "CardSpecification",
        component: () => import("../views/CardSpecification/CardSpecification"),
      },
      {
        path: "CertificateRecordSpecs",
        name: "CertificateRecordSpecs",
        component: () => import("../views/CertificateRecordSpecs/CertificateRecordSpecs"),
      },
      {
        path: "CertificateRecordLook",
        name: "CertificateRecordLook",
        component: () => import("../views/CertificateRecordLook/CertificateRecordLook"),
      },
      {
        path: "CertificateRecordSub",
        name: "CertificateRecordSub",
        component: () => import("../views/CertificateRecordSub/CertificateRecordSub"),
      },
      {
        path: "YdStockMerchant",
        name: "YdStockMerchant",
        component: () => import("../views/YdStockMerchant/YdStockMerchant"),
      },
      {
        path: "goods",
        name: "goods",
        component: () => import("../views/goods/goods"),
      },
      {
        path: "goodsList",
        name: "goodsList",
        component: () => import("../views/goods/goodsList"),
      },
      {
        path: "cityAuthBill",
        name: "cityAuthBill",
        component: () => import("../views/cityAuth/cityAuthBill"),
      },
      {
        path: "cityAuthExchange",
        name: "cityAuthExchange",
        component: () => import("../views/cityAuth/cityAuthExchange"),
      },
      {
        path: "merchartsCity",
        name: "merchartsCity",
        component: () => import("../views/commercialTenant/merchartsCity"),
      },
      {
        path: "refundBill",
        name: "refundBill",
        component: () => import("../views/refundBill/refundBill"),
      },
      {
        path: "keysMsg",
        name: "keysMsg",
        component: () => import("../views/keysMsg/keysMsg"),
      },
      {
        path: "FinancialStatistics",
        name: "FinancialStatistics",
        component: () =>
          import("../views/FinancialStatistics/FinancialStatistics"),
      },
      {
        path: "rechargeRecord",
        name: "rechargeRecord",
        component: () => import("../views/FinancialStatistics/rechargeRecord"),
      },

      {
        path: "noticeMsg",
        name: "noticeMsg",
        component: () => import("../views/noticeMsg/noticeMsg"),
      },
      {
        path: "verificationDetails",
        name: "verificationDetails",
        component: () =>
          import("../views/verificationDetails/verificationDetails"),
      },
      {
        path: "merchantReview",
        name: "merchantReview",
        component: () => import("../views/commercialTenant/merchantReview"),
      },
      {
        path: "invoiceBalanceAdjustment",
        name: "invoiceBalanceAdjustment",
        component: () =>
          import("../views/InvoiceReminder/invoiceBalanceAdjustment"),
      },

      {
        path: "logActivityStatistics",
        name: "logActivityStatistics",
        component: () => import("../views/sysLog/logActivityStatistics"),
      },
      {
        path: "couponAdditionalInfo",
        name: "couponAdditionalInfo",
        component: () =>
          import("../views/couponAdditionalInfo/couponAdditionalInfo"),
      },
      {
        path: "systemCorporate",
        name: "systemCorporate",
        component: () => import("../views/systemCorporate/systemCorporate"),
      },
      {
        path: "existingLog",
        name: "existingLog",
        component: () => import("../views/sysLog/existingLog"),
      },
      {
        path: "xiaoXiangReceiptRecord",
        name: "xiaoXiangReceiptRecord",
        component: () =>
          import("../views/xiaoXiangReceiptRecord/xiaoXiangReceiptRecord"),
      },
      {
        path: "xiaoXiangReceiptRecordTj",
        name: "xiaoXiangReceiptRecordTj",
        component: () =>
          import("../views/xiaoXiangReceiptRecord/xiaoXiangReceiptRecordTj"),
      },
      {
        path: "invoiceDetailStatistics",
        name: "invoiceDetailStatistics",
        component: () =>
          import("../views/invoiceDetailStatistics/invoiceDetailStatistics"),
      },
      {
        path: "RightsFundError",
        name: "RightsFundError",
        component: () => import("../views/RightsFundError/RightsFundError"),
      },
      {
        path: "RightsFundBill",
        name: "RightsFundBill",
        component: () => import("../views/RightsFundBill/RightsFundBill"),
      },
      {
        path: "RightsFundRollback",
        name: "RightsFundRollback",
        component: () => import("../views/RightsFundRollback/RightsFundRollback"),
      },
      {
        path: "RightsFundDeduct",
        name: "RightsFundDeduct",
        component: () => import("../views/RightsFundDeduct/RightsFundDeduct"),
      },
      {
        path: "RightsFundLog",
        name: "RightsFundLog",
        component: () => import("../views/RightsFundLog/RightsFundLog"),
      },
      {
        path: "RightsFundLogStatistics",
        name: "RightsFundLogStatistics",
        component: () => import("../views/RightsFundLogStatistics/RightsFundLogStatistics"),
      },
      {
        path: "RightsFundLogCopy",
        name: "RightsFundLogCopy",
        component: () => import("../views/RightsFundLogCopy/RightsFundLogCopy"),
      },
      {
        path: "Blacklist",
        name: "Blacklist",
        component: () => import("../views/Blacklist/Blacklist"),
      },
      {
        path: "BeiguoOrder",
        name: "BeiguoOrder",
        component: () => import("../views/BeiguoOrder/BeiguoOrder"),
      },
      {
        path: "BeiguoSpecs",
        name: "BeiguoSpecs",
        component: () => import("../views/BeiguoSpecs/BeiguoSpecs"),
      },
      {
        path: "BeiguoNotify",
        name: "BeiguoNotify",
        component: () => import("../views/BeiguoNotify/BeiguoNotify"),
      },
      {
        path: "ShopType",
        name: "ShopType",
        component: () => import("../views/ShopType/ShopType"),
      },
      {
        path: "SpecsRelationShop",
        name: "SpecsRelationShop",
        component: () => import("../views/SpecsRelationShop/SpecsRelationShop"),
      },
      {
        path: "EquityBalanceQuery",
        name: "EquityBalanceQuery",
        component: () => import("../views/EquityBalanceQuery/EquityBalanceQuery"),
      },
      {
        path: "GoodsYd",
        name: "GoodsYd",
        component: () => import("../views/GoodsYd/GoodsYd"),
      },
      {
        path: "SysRegisterCode",
        name: "SysRegisterCode",
        component: () => import("../views/SysRegisterCode/SysRegisterCode"),
      },
      {
        path: "RightsFundDeductCopy",
        name: "RightsFundDeductCopy",
        component: () => import("../views/RightsFundDeductCopy/RightsFundDeductCopy"),
      },
      {
        path: "RightsFundRollbackCopy",
        name: "RightsFundRollbackCopy",
        component: () => import("../views/RightsFundRollbackCopy/RightsFundRollbackCopy"),
      },
      {
        path: "YbtPayOrder",
        name: "YbtPayOrder",
        component: () => import("../views/YbtPayOrder/YbtPayOrder.vue"),
      },
      {
        path: "YbtPayOrderNotify",
        name: "YbtPayOrderNotify",
        component: () => import("../views/YbtPayOrderNotify/YbtPayOrderNotify.vue"),
      },
      {
        path: "YbtPayOrderResponse",
        name: "YbtPayOrderResponse",
        component: () => import("../views/YbtPayOrderResponse/YbtPayOrderResponse.vue"),
      },
      {
        path: "YbtPayOrderCopy",
        name: "YbtPayOrderCopy",
        component: () => import("../views/YbtPayOrderCopy/YbtPayOrderCopy.vue"),
      },
      {
        path: "RightsFundWrongReplace",
        name: "RightsFundWrongReplace",
        component: () => import("../views/RightsFundWrongReplace/RightsFundWrongReplace.vue"),
      },
      {
        path: "PhoneEightFive",
        name: "PhoneEightFive",
        component: () => import("../views/PhoneEightFive/PhoneEightFive"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
